export const currencyBookStrings = {
  resetButtonText: 'Reset',
  submitButtonText: 'Save Changes',
  // TODO
  deleteCurrencyBookWarning:
    'Deleting the currency book will also delete any bank accounts associated with it.',
  deleteButtonText: 'Delete',
  noBankAccountsWarning: (name: string) =>
    `There are currently no bank accounts associated with ${name}`,
};
